import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import DATA_WAREHOUSE_EXPORT_CREATE from '../mutations/DATA_WAREHOUSE_EXPORT_CREATE';

const useDataWarehouseCreateReport = () => {
    const [ createNewReport ] = useMutation( DATA_WAREHOUSE_EXPORT_CREATE );

    const createReport = async ( saveData ) => {
        try {
            const response = await createNewReport(  { variables: { input: saveData } } );
            const success = response?.data?.createDataWarehouseExport?.id;
           
            if ( success ) {
                return {
                    success: true,
                    response: response.data.createDataWarehouseExport
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating report', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createReport
        };
    }, [] );
};

export default useDataWarehouseCreateReport;
